import React from 'react';
import { Accordion, FormControl, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import IconButton from 'components/common/IconButton';
import { OptionType } from 'components/common/types';

type UsersFiltersPropsTypes = {
  values: {
    search: string;
    status?: OptionType;
  };
  handleSubmit: () => void;
  setFieldValue: (field: string, value: any) => void;
  loading: boolean;
  statusOptions: { value: string; label: string }[];
};

const UsersFilters = (props: UsersFiltersPropsTypes) => {
  const {
    values: { status, search } = {},
    handleSubmit,
    setFieldValue,
    loading,
    statusOptions
  } = props;

  return (
    <div className="w-100">
      <div className="w-50 d-flex gap-3 mb-3">
        <div className="search-box">
          <FormControl
            name="account"
            type="search"
            value={search}
            onChange={e => setFieldValue('search', e?.target?.value)}
            placeholder="Введите номер телефона или имя пользователя"
            aria-label="Введите номер телефона или имя пользователя"
            disabled={loading}
          />
        </div>
        {/* @ts-ignore */}
        <IconButton
          className="d-flex align-items-center gap-2"
          variant="primary"
          id="button-addon2"
          disabled={loading}
          icon="search"
          iconAlign="left"
          onClick={handleSubmit}
        >
          Поиск
          {loading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : null}
        </IconButton>
      </div>
      <Accordion className="mb-3">
        <div className="d-flex align-items-start justify-content-between">
          <div className="w-50">
            <Select
              isClearable
              options={statusOptions as any}
              placeholder="Статус"
              isDisabled={loading}
              classNamePrefix="react-select"
              value={status}
              onChange={value => { setFieldValue('status', value); handleSubmit(); }}
            />
          </div>
        </div>
      </Accordion>
    </div>
  );
};

export default UsersFilters;
